import React from "react";
import { useSurvey } from "../../hooks/useSurvey";
import { Header } from "../../shared/Header";
import styles from "./styles.module.scss";
import { Success } from "../../shared/Success";
import { ButtonSubmit } from "../../shared/ButtonSubmit";
import { useAnswers } from "../../hooks/useAnswers";
import { SURVEY_TYPE } from "../../../../api/surveys/config";
import { Question } from "../../shared/Question";
import { Match } from "../../../../utilities/fp";
import { Empty } from "../../../../shared/Empty/Empty";
import { useSubmit } from "../../hooks/useSubmit";
import { Deleted } from "../../shared/Deleted";

export function Content() {
  var submit = useSubmit();
  var { data: survey, hash } = useSurvey();
  var { answers, comments } = useAnswers();

  var renderQuestion = (q) => {
    var valueProps = {
      value: answers.value[q.id],
      onChange: (x) => answers.update(q.id, x),
    };

    switch (q.type) {
      case SURVEY_TYPE.text:
        return (
          <Question.Text
            key={q.id}
            question={q.question}
            description={q.description}
            required={q.isRequired}
            {...valueProps}
          />
        );
      case SURVEY_TYPE.binary:
        return (
          <Question.Binary
            key={q.id}
            question={q.question}
            description={q.description}
            required={q.isRequired}
            {...valueProps}
          />
        );
      case SURVEY_TYPE.singleChoice:
        return (
          <Question.SingleChoice
            key={q.id}
            question={q.question}
            description={q.description}
            required={q.isRequired}
            choices={q.options}
            {...valueProps}
          />
        );
      case SURVEY_TYPE.multipleChoice:
        return (
          <Question.MultipleChoice
            key={q.id}
            question={q.question}
            description={q.description}
            required={q.isRequired}
            choices={q.options}
            {...valueProps}
          />
        );
      case SURVEY_TYPE.scale:
        return (
          <Question.Scale
            key={q.id}
            question={q.question}
            description={q.description}
            required={q.isRequired}
            allowComment={q.allowComment}
            comment={comments.value[q.id] || ""}
            onCommentChange={(x) => comments.update(q.id, x)}
            {...valueProps}
          />
        );
      case SURVEY_TYPE.file:
        return (
          <Question.File
            key={q.id}
            id={q.id}
            question={q.question}
            description={q.description}
            required={q.isRequired}
            {...valueProps}
          />
        );
      default:
        return null;
    }
  };

  var onSubmit = () => {
    submit.initiate({
      hash,
      survey,
      answers: answers.value,
      comments: comments.value,
    });
  };

  return (
    <>
      <Header />
      <div className={styles.root}>
        {Match.of(true)
          .on(survey?.finished, () => <Success />)
          .on(survey?.deleted, () => <Deleted />)
          .on(survey?.questions?.length === 0, () => (
            <Empty size="big" position="center" color="gray1" />
          ))
          .or(
            <div className={styles.questions}>
              {survey?.title && <h1>{survey.title}</h1>}
              {survey?.questions?.map(renderQuestion)}
              <div className={styles.footer}>
                <ButtonSubmit isLoading={submit.isLoading} submit={onSubmit} />
              </div>
            </div>,
          )
          .join()}
      </div>
    </>
  );
}
